import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ChangeCampaignName,
  ChangeChannel,
  ChangeCountry,
  ChangeEndDate,
  ChangeSchema,
  ChangeStartDate,
  ClearEndDate,
  ClearOptions,
  ClearStartDate,
  GetChannelsSuccess,
  GetCountriesSuccess,
  GetSchemasSuccess,
  PanelStatusChanged,
} from '../actions/search.actions';
import { CampaignManagementState } from '../models/campaign-management.model';

export const initialState: CampaignManagementState = {
  panelExpanded: true,
  campaignName: '',
  schemas: [],
  schemaId: 0,
  schema: '',
  countries: [],
  countryId: 0,
  countryName: '',
  channelOptions: [],
  channel: '',
  startDate: new Date(0),
  startDateFormat: '',
  endDate: new Date(0),
  endDateFormat: '',
};

export const CampaignManagementReducer = createReducer(
  initialState,
  on(GetSchemasSuccess, (state, { res }) => ({
    ...state,
    schemas: res,
  })),
  on(GetCountriesSuccess, (state, { res }) => ({
    ...state,
    countries: res,
  })),
  on(GetChannelsSuccess, (state, { res }) => ({
    ...state,
    channelOptions: res,
  })),
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(ChangeCampaignName, (state, { campaignName }) => ({
    ...state,
    campaignName,
  })),
  on(ChangeSchema, (state, { schemaId, schema }) => ({
    ...state,
    schemaId,
    schema,
  })),
  on(ChangeCountry, (state, { countryName, countryId }) => ({
    ...state,
    countryName,
    countryId,
  })),
  on(ChangeChannel, (state, { channel }) => ({
    ...state,
    channel,
  })),
  on(ChangeStartDate, (state, { startDate, startDateFormat }) => ({
    ...state,
    startDate,
    startDateFormat,
  })),
  on(ChangeEndDate, (state, { endDate, endDateFormat }) => ({
    ...state,
    endDate,
    endDateFormat,
  })),
  on(ClearStartDate, (state) => ({
    ...state,
    startDate: new Date(0),
    startDateFormat: '',
  })),
  on(ClearEndDate, (state) => ({
    ...state,
    endDate: new Date(0),
    endDateFormat: '',
  })),
  on(ClearOptions, (state) => ({
    ...state,
    campaignName: '',
    schemaId: 0,
    schema: '',
    countryId: 0,
    countryName: '',
    channel: '',
    startDate: new Date(0),
    startDateFormat: '',
    endDate: new Date(0),
    endDateFormat: '',
  })),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
